import { createFileRoute, Link } from "@tanstack/react-router";
import { Target } from "lucide-react";
import { ServicePage } from "@/components/site/ServicePage";
import { serviceFaqs } from "@/data/serviceFaqs";
import { canonicalLinks, ogUrl, jsonLd, serviceSchema, ogImage, breadcrumbSchema, faqPageSchema, webPageSchema, absoluteUrl } from "@/lib/seo";

export const Route = createFileRoute("/services/strategy-execution")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Strategy to Execution | Ajility Fractional COO" },
      {
        name: "description",
        content:
          "Turn strategy into a 90-day operating rhythm with a few priorities, named owners, clear dates and weekly follow-through across the team.",
      },
      { property: "og:title", content: "Strategy to Execution | Ajility Fractional COO" },
      {
        property: "og:description",
        content:
          "Turn strategy into a 90-day operating rhythm with a few priorities, named owners, clear dates and weekly follow-through across the team.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:title", content: "Strategy to Execution | Ajility Fractional COO" },
      { name: "twitter:description", content: "Turn strategy into a 90-day operating rhythm with a few priorities, named owners, clear dates and weekly follow-through across the team." },
      ...ogImage("services-strategy-execution", "Strategy to execution by Ajility"),
      ogUrl("/services/strategy-execution"),
    ],
    links: canonicalLinks("/services/strategy-execution"),
    scripts: [
      jsonLd(webPageSchema({ image: "services-strategy-execution", mainEntityId: `${absoluteUrl("/services/strategy-execution")}#service`, path: "/services/strategy-execution", name: "Strategy to Execution | Ajility Fractional COO", description: "Turn strategy into a 90-day operating rhythm with a few priorities, named owners, clear dates and weekly follow-through across the team." })),
      jsonLd(breadcrumbSchema([{ name: "Services", path: "/services" }, { name: "Strategy to Execution", path: "/services/strategy-execution" }])),jsonLd(serviceSchema({ name: "Strategy to Execution", description: "Turn strategy into a 90-day operating rhythm with a few priorities, named owners, clear dates and weekly follow-through across the team.", path: "/services/strategy-execution", slug: "strategy-execution", price: 6900 })), jsonLd(faqPageSchema("/services/strategy-execution", serviceFaqs["strategy-execution"], `${absoluteUrl("/services/strategy-execution")}#service`))],
  }),
  component: () => (
    <ServicePage slug="strategy-execution"
      Icon={Target}
      eyebrow="Service: Strategy to Execution"
      title="Strategy execution through a disciplined 90-day operating rhythm."
      intro={<>A fractional COO sits in the leadership rhythm and is accountable for delivery, not just the plan. Ajility converts vision into a 12-month roadmap, 90-day priorities and weekly tracking, reviewed each quarter. Turn the plan into a few priorities with a name, a date and a weekly check against each one. Ajility converts vision into a 12-month roadmap, <Link to="/insights/$slug" params={{ slug: "strategy-execution-90-day-rhythm" }} className="underline decoration-white/40 underline-offset-4 hover:decoration-frost">90-day priorities and weekly tracking</Link>.</>}
      problems={[
        "Great offsites that result in zero action.",
        "Annual plans forgotten by February.",
        "Teams misaligned on what the top priorities actually are.",
        "Strategy is disconnected from daily operations.",
      ]}
      installs={[
        "Clear 1-year plans broken into 90-day execution sprints.",
        "Top 3 to 5 company priorities with assigned owners.",
        "A system for cascading goals to departmental levels.",
        "Weekly tracking of priority progress.",
      ]}
      process={[
        { title: "Extract", desc: "Clarify the founder's vision and long-term targets." },
        { title: "Translate", desc: "Break the vision down into an actionable 12-month roadmap." },
        { title: "Sprint", desc: "Define strict 90-day priorities and assign owners." },
        { title: "Track", desc: "Install weekly execution tracking to ensure momentum." },
      ]}
    />
  ),
});
